import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export function fromJSDate(jsDate: Date) {
	return new NgbDate(jsDate.getFullYear(), jsDate.getMonth() + 1, jsDate.getDate());
}

export function toJSDate(date: NgbDate) {
	const jsDate = new Date(date.year, date.month - 1, date.day, 12);
	// this is done avoid 30 -> 1930 conversion
	if (!isNaN(jsDate.getTime())) {
		jsDate.setFullYear(date.year);
	}
	return jsDate;
}